
// NameField

import React from 'react';

function NameField({ value, onChange }) {
  return (
    <div style={{ marginBottom: '0px' }}>
      <input 
        type="text"
        placeholder="Digite o Nome ou Razão Social"
        style={{ width: '500px', height: '30px' }}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}

export default NameField;